export default __webpack_public_path__ + "static/media/Raider.ed46e12f.svg";